import './Header.css';
import React, { useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { resetStep, setFromSummaryPage } from '../../store/reducers/flowStepReducer';
// import { setFromSummaryPage } from '../../store/reducers/myPlansReducer';
import { parseMobileParamsNew } from './../../utils/Common.js';
import {checkCustomer} from '../../store/reducers/profileReducer';

const Header = () => {
  const location = useLocation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log("Header11");

const planExistCustomer = useSelector(
  (state) => state.profileList?.planExistCustomer
);

useEffect(() => {
  if (location.pathname == '/customer-profile') {
     const parsed = parseMobileParamsNew();
    
    if (parsed) {
      console.log("Header parsed:", parsed);
      console.log("Header parsed mobileNumber :", parsed.mobileNumber);
      console.log("Header parsed source :", parsed.source);
      console.log("Header parsed verifiedData :", parsed.verifiedData);

      let verifiedData = parsed.verifiedData;
      let mobileNumber = parsed.mobileNumber;
        localStorage.setItem('mblnbr', JSON.stringify(mobileNumber));
        dispatch(checkCustomer(verifiedData));
    }
  }
  if(planExistCustomer === false){
  }
}, []);


  // const handleBack = () => {
  //   switch (location.pathname) {
  //     case '/membership-features':
  //       navigate('/');
  //       break;
  //     case '/customer-profile':
  //       // navigate('/membership-features');
  //       navigate('/');
  //       break;
  //     case '/payment-status':
  //       navigate('/customer-profile');
  //       break;
  //     default:
  //       navigate(-1);
  //   }
  // };



  const isHomePage = location.pathname === '/';
  const isSummaryPage = location.pathname === '/summary';
  const raiseClaim = location.pathname === '/raise-claim';
  const trackClaim = location.pathname === '/track-claim';

  const handleBack = () => {
    if (isSummaryPage) {
      const storedData = localStorage.getItem('customerProfile');
      if (storedData) {
        localStorage.setItem('customerProfile', storedData);
      }
      dispatch(resetStep());
      dispatch(setFromSummaryPage(true));
      console.log("isSummaryPageisSummaryPage",isSummaryPage);
      navigate('/customer-profile');
    } else {
      switch (location.pathname) {
        case '/membership-features':
          navigate('/');
          break;
        case '/customer-profile':
          navigate('/');
          break;
        case '/payment-status':
          navigate('/');
          break;
        case '/my-plans':
          navigate('/');
          break;
        case '/raise-claim':
          navigate('/my-plans');
          break;
        case '/track-claim':
          navigate('/my-plans');
          break;
        default:
          navigate(-1);
      }
    }
  };

console.log("planExistCustomer",planExistCustomer);

  return (
    <header className="header-main">
      <div className="header-content">
        {!isHomePage && raiseClaim && (
          <div className="header-content-menu" onClick={handleBack}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/previous.svg`}
              alt="Back"
              className="header-image-menu"
            />
            <span>Raise a Claim</span>
          </div>
        )}
        {!isHomePage && !raiseClaim && trackClaim && (
          <div className="header-content-menu" onClick={handleBack}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/previous.svg`}
              alt="Back"
              className="header-image-menu"
            />
            <span>Track Claim</span>
          </div>
        )}
        {!isHomePage &&  !trackClaim && !raiseClaim && (
          <div className="header-content-menu" onClick={handleBack}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/previous.svg`}
              alt="Back"
              className="header-image-menu"
            />
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;